import axios from "axios";

const endpoint_url = "/message/whatsappMessageTemplate/update";

const updateWhatsappMessageTemplate = (requestBody) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, requestBody)
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default updateWhatsappMessageTemplate;
